import Vue from 'vue'
import Constants from 'src/utilities/constants'
import {ptracGetEntities, ptracPost} from 'src/utilities/ptracApi'
import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import {resetResults} from 'src/utilities/vuex2'

let initialState = {
  results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.putPayload = (state) => (notification) => {
  notification.seenAt = new Date()
  return {
    id: notification.id,
    endpoint: 'notifications',
    data: notification
  }
}
getters.notSeenCount = (state) => {
  let count = 0
  state.results.forEach((notification) => {
    if (!notification.seenAt) {
      count++
    }
  })
  return count
}

const mutations = make.mutations(state)
mutations.resetResults = resetResults

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchNWeeksNotifications({ commit, dispatch }, payload) {
      let url = 'notifications/search/findByToUserIdAndCreatedAtAfterOrderByCreatedAtDesc?toUserId=' + payload.userId + '&createdAt=' + payload.createdAt
      const response = await ptracGetEntities(url)
      if (OK === response.status) {
        commit('results', response.data)
        commit('apiHealth/ptracActive', Constants.HEALTH_CHECK_STATUSES.UP, {root: true})
      } else {
        commit('apiHealth/ptracActive', Constants.HEALTH_CHECK_STATUSES.DOWN, {root: true})
      }
      return response
    },
    async markAllAsSeen({}, payload) {
      let url = 'notifications/markAllAsSeen?userId=' + payload.userId + '&createdAt=' + payload.createdAt
      return await ptracPost(url, null, Constants.HEADERS.DEFAULT)
    }
  }
}
